module.exports = __webpack_public_path__ + "static/img/默认@2x.a80fbf95.jpg";